import SimpleDataGrid from '../../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../../Tables/SimpleDataGridItem';
import LabelAndReportBlock from './LabelAndReportBlock';
import { userFinancialWellnessChangeColumns } from '../UserFinancialWellnessChange';
import { userFeedbackColumns } from '../UserFeedback';
import { userCheckupsColumns } from '../UserCheckups';
import { userCoursesColumns } from '../UserCourses';
import { userResourcesColumns } from '../UserResources';
import { userSearchesColumns } from '../UserSearches';
import { userMoneyPersonalityColumns } from '../UserMoneyPersonality';
import { utcToLocalMidnight } from '../../../../helpers';
import { format } from 'date-fns';
import _ from 'lodash';
import { CircularProgress } from '@mui/material';
import { userCreditEnrollmentColumns } from '../UserCreditEnrollment';
import { userMeditationsColumns } from '../UserMeditations';
import { userJournalsColumns } from '../UserJournals';

const UserDetailsSection = ({ reportDataCollection, inFlight }) => {
    // Format as M/D/YYYY using date-fns on the local-midnight Date
    const toMDY = (iso) => {
        if (!iso) return null;
        const dt = utcToLocalMidnight(iso);
        return dt ? format(dt, 'M/d/yyyy') : null;
    };

    if (inFlight) {
        return (
            <div
                className="flex justify-center"
                role="status"
                aria-label="Loading user details"
            >
                <CircularProgress />
            </div>
        );
    }
    if (!reportDataCollection) {
        return null;
    }

    return (
        <>
            <div className="mb-2 font-semibold text-gray-800">User details</div>
            <div>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Username:"
                        value={reportDataCollection.userDetails?.username}
                    />
                    <SimpleDataGridItem
                        label="Name:"
                        value={`${reportDataCollection.userDetails?.firstName} ${reportDataCollection.userDetails?.lastName}`}
                    />
                    <SimpleDataGridItem
                        label="Primary Email Address:"
                        value={reportDataCollection.userDetails?.primaryEmailAddress}
                    />
                    <SimpleDataGridItem
                        label="User ID (client):"
                        value={reportDataCollection.userDetails?.secondaryId}
                    />
                    <SimpleDataGridItem
                        label="User ID (internal):"
                        value={reportDataCollection.userDetails?.userId}
                    />
                    <SimpleDataGridItem
                        label="Alternate ID:"
                        value={reportDataCollection.userDetails?.alternateId}
                    />
                    <SimpleDataGridItem
                        label="Cobrand:"
                        value={reportDataCollection.userDetails?.cobrandName}
                    />
                    <SimpleDataGridItem
                        label="Cobrand Description:"
                        value={reportDataCollection.userDetails?.cobrandDescription}
                    />
                    <SimpleDataGridItem
                        label="Unit Name:"
                        value={reportDataCollection.userDetails?.unitName}
                    />
                    <SimpleDataGridItem
                        label="Registration Date:"
                        value={toMDY(reportDataCollection.userDetails?.createdOn)}
                    />
                    <SimpleDataGridItem
                        label="Most Recent Log In:"
                        value={toMDY(
                            reportDataCollection.userLogins?.length
                                ? _(reportDataCollection.userLogins)
                                      .map((x) => x.loginDatetime)
                                      .max()
                                : null
                        )}
                    />
                    <SimpleDataGridItem
                        label="Total Login Count:"
                        value={reportDataCollection.userLogins?.length || 0}
                    />
                    <SimpleDataGridItem
                        label="Total XP:"
                        value={reportDataCollection.totalXp || 0}
                    />
                </SimpleDataGrid>
            </div>
            <LabelAndReportBlock
                label="Courses"
                data={reportDataCollection.userCourses}
                columns={userCoursesColumns}
            />
            <LabelAndReportBlock
                label="Resources"
                data={reportDataCollection.userResources}
                columns={userResourcesColumns}
            />
            <LabelAndReportBlock
                label="Checkups"
                data={reportDataCollection.userCheckups}
                columns={userCheckupsColumns}
            />
            <LabelAndReportBlock
                label="Financial Wellness Change"
                data={reportDataCollection.userFinancialWellnessChange}
                columns={userFinancialWellnessChangeColumns}
            />
            <LabelAndReportBlock
                label="Money Personality"
                data={reportDataCollection.userMoneyPersonality}
                columns={userMoneyPersonalityColumns}
            />
            <LabelAndReportBlock
                label="Meditations"
                data={reportDataCollection.userMeditations}
                columns={userMeditationsColumns}
            />
            <LabelAndReportBlock
                label="Searches"
                data={reportDataCollection.userSearches}
                columns={userSearchesColumns}
            />
            <LabelAndReportBlock
                label="Feedback"
                data={reportDataCollection.userFeedback}
                columns={userFeedbackColumns}
            />
            <LabelAndReportBlock
                label="Credit Enrollment"
                data={reportDataCollection.userCreditEnrollment}
                columns={userCreditEnrollmentColumns}
            />
            <LabelAndReportBlock
                label="Journals"
                data={reportDataCollection.userJournals}
                columns={userJournalsColumns}
            />
        </>
    );
};

export default UserDetailsSection;
